import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData } from '../../functionalComponents/dataFormatFunctions';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // width: '100%',
        // backgroundColor: '#EDEDED',
        '& .MuiStepLabel-label': {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 500,
        },
      },
      table: {
        minWidth: 650,
      },
      tableContainer: {
          boxShadow: 'none', // Remove border and shadow from the container
          marginBottom:'3rem',
      },
      tableCell: {
        textAlign: 'left',
        borderBottom: 'none', // Remove bottom border
        width: '16.666%', // Set equal width for each cell
        padding: '16px', // Standard padding for consistency
      },
      headerCell: {
        fontWeight: 'bold',
      },
}));

export default function BatchDetailsRow(props) {
  const { data } = props;
  const classes = useStyles();

    return (
        // <Box className={classes.root}>
        <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Plant ID</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>GMP Batch</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Batch Number</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>MBR number</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>Start Date</TableCell>
              <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>End Date (expected)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableCell}>{presentFormatedData(data.plantID)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data.gmpBatchNumber)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data.batchNumber)}</TableCell>
              <TableCell className={classes.tableCell}>{presentFormatedData(data.numberBMR)}</TableCell>
              <TableCell className={classes.tableCell}>{data.batchStartDate ? moment(data.batchStartDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
              <TableCell className={classes.tableCell}>{data.batchEndDate ? moment(data.batchEndDate).format('DD-MMM-YYYY').toUpperCase():' - '}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
            // </Box>
  );
}
